import {Pipe, PipeTransform} from '@angular/core';
import { Store } from '@ngxs/store';
import { PharmacyState } from '../../states/pharmacy/pharmacy.state';

@Pipe({
  name: 'rxNumber',
})
export class RxNumberPipe implements PipeTransform {
  /**
   *
   */
  constructor(private store: Store) {}

  transform(value: any) {
    if (!value.rxNumber) {
       return "";
    }

    if (this.store.selectSnapshot(PharmacyState.enableC3toC5Drugs)) {
      return value.rxNumber + ` (${value.fillNumber || 0})`;
    }
    return value.rxNumber;
  }
}  